'use client';
import { Toaster as Sonner } from 'sonner';

const Toaster = (props) => (
  <Sonner
    theme="light"
    className="toaster group"
    toastOptions={{
      classNames: {
        toast: 'group toast group-[.toaster]:bg-white group-[.toaster]:text-ink group-[.toaster]:border group-[.toaster]:border-ink/10 group-[.toaster]:shadow-xl rounded-xl',
        description: 'group-[.toast]:text-ink-mute',
        actionButton: 'group-[.toast]:bg-ink group-[.toast]:text-cream-50',
        cancelButton: 'group-[.toast]:bg-ink/5 group-[.toast]:text-ink',
      },
    }}
    position="top-center"
    {...props}
  />
);

export { Toaster };
